var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestonesActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Category"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.604 9.46C3.299 10.323 4.564 10.5 6.25 10.5C7.936 10.5 9.201 10.323 9.896 9.46C10.5 8.711 10.5 7.688 10.5 6.25C10.5 3.38 10.319 2 6.25 2C2.181 2 2 3.38 2 6.25H2.53704L2.53901 6.25703L2 6.275C2 7.689 2 8.711 2.604 9.46ZM13.604 9.46C14.299 10.323 15.564 10.5 17.25 10.5C18.936 10.5 20.201 10.323 20.896 9.46C21.5 8.711 21.5 7.688 21.5 6.25C21.5 3.38 21.319 2 17.25 2C13.181 2 13 3.38 13 6.25H13.75L13 6.275C13 7.689 13 8.711 13.604 9.46ZM6.25 21.5C4.564 21.5 3.299 21.323 2.604 20.46C2 19.711 2 18.689 2 17.275L2.75 17.25H2C2 14.38 2.181 13 6.25 13C10.319 13 10.5 14.38 10.5 17.25C10.5 18.688 10.5 19.711 9.896 20.46C9.201 21.323 7.936 21.5 6.25 21.5ZM13.604 20.46C14.299 21.323 15.564 21.5 17.25 21.5C18.936 21.5 20.201 21.323 20.896 20.46C21.5 19.711 21.5 18.688 21.5 17.25C21.5 14.38 21.319 13 17.25 13C13.181 13 13 14.38 13 17.25H13.75L13 17.275C13 18.689 13 19.711 13.604 20.46Z",
    fill: "#7A5038"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestonesActiveIcon);
export default __webpack_public_path__ + "static/media/milestonesActiveIcon.d04d9a592bad3d5311e274e8739f5054.svg";
export { ForwardRef as ReactComponent };